import React from "react";
import { Dropdown as SemanticDropdown } from "semantic-ui-react";
import Icon from "../Icon";
import "./HuiDropdown.scss";
import PropTypes from "prop-types";

export const HuiDropdown = ({
  className,
  bigger = false,
  disabled = false,
  error = false,
  ...props
}) => {
  return (
    <SemanticDropdown
      icon={<Icon type="keyboard_arrow_down" className="default-icon" />}
      className={`hireart-ds-dropdown ${
        bigger ? "alternative" : ""
      } ${className}`}
      disabled={disabled}
      error={error}
      {...props}
      selectOnBlur={false}
      selection
    />
  );
};

HuiDropdown.propTypes = {
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  bigger: PropTypes.bool,
};

